"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shopCarOrderApi = _interopRequireWildcard(require("@/api/shopCarOrderApi"));
var _parkingCardOperation = require("../parkingCardOperation");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FreezeParkingCardDialog',
  data: function data() {
    var _this = this;
    var checkFreezeTime = function checkFreezeTime(rule, value, callback) {
      if (!_this.form.freezeStart || !_this.form.freezeEnd) {
        callback(new Error('请选择冻结时间'));
        return;
      }
      if (_this.form.freezeEnd < _this.form.freezeStart) {
        callback(new Error('冻结结束时间必须晚于或等于冻结开始时间'));
        return;
      }
      if (_this.isOutOfValidDate(_this.form.freezeStart) || _this.isOutOfValidDate(_this.form.freezeEnd)) {
        callback(new Error('冻结时间只能选择月卡有效期内的日期'));
        return;
      }
      callback();
    };
    return {
      visible: false,
      loading: false,
      submitting: false,
      orderNo: '',
      display: {
        productName: '',
        parkName: '',
        plateNo: '',
        validStartTime: '',
        validEndTime: ''
      },
      form: {
        freezeStart: '',
        freezeEnd: '',
        reason: '',
        attachment: null
      },
      freezePickerOptions: {
        disabledDate: function disabledDate(time) {
          return _this.isOutOfValidDate(time);
        }
      },
      rules: {
        freezeStart: [{
          required: true,
          validator: checkFreezeTime,
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      var _this2 = this;
      if (!row || !row.orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      this.resetForm();
      this.orderNo = row.orderNo;
      this.visible = true;
      this.fillDisplay(row);
      this.loading = true;
      shopCarOrderApi.getParkingCardOrderDetail(row.orderNo).then(function (res) {
        _this2.fillDisplay(_objectSpread(_objectSpread({}, row), res || {}));
      }).finally(function () {
        _this2.loading = false;
      });
    },
    fillDisplay: function fillDisplay(data) {
      this.display = {
        productName: data.productName || '',
        parkName: data.parkName || '',
        plateNo: data.plateNo || '',
        validStartTime: this.formatDate(data.validStartTime),
        validEndTime: this.formatDateTime(data.validEndTime)
      };
    },
    formatDate: function formatDate(val) {
      if (!val) return '';
      return String(val).replace('T', ' ').slice(0, 10);
    },
    formatDateTime: function formatDateTime(val) {
      if (!val) return '';
      var s = String(val).replace('T', ' ');
      return s.length >= 19 ? s.slice(0, 19) : s;
    },
    parseDateStart: function parseDateStart(val) {
      if (!val) return null;
      var date = val instanceof Date ? new Date(val.getTime()) : new Date(String(val).replace(/-/g, '/'));
      if (Number.isNaN(date.getTime())) return null;
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    },
    isOutOfValidDate: function isOutOfValidDate(val) {
      var current = this.parseDateStart(val);
      var start = this.parseDateStart(this.display.validStartTime);
      var end = this.parseDateStart(this.display.validEndTime);
      if (current == null) return false;
      if (start != null && current < start) return true;
      if (end != null && current > end) return true;
      return false;
    },
    chooseAttachment: function chooseAttachment() {
      var _this3 = this;
      this.$modalUpload(function (items) {
        if (!items || !items[0]) return;
        try {
          _this3.form.attachment = (0, _parkingCardOperation.createOperationAttachment)(items[0]);
        } catch (error) {
          _this3.$message.error(error.message);
        }
      }, '1', 'system', false, {
        maxSizeKB: 1024,
        maxSizeErrorMsg: '附件大小超过1MB，请重新上传~',
        acceptExts: ['jpg', 'png', 'pdf'],
        acceptErrorMsg: '附件格式仅支持JPG、PNG、PDF，请重新上传'
      });
    },
    resetForm: function resetForm() {
      var _this4 = this;
      this.form = {
        freezeStart: '',
        freezeEnd: '',
        reason: '',
        attachment: null
      };
      this.$nextTick(function () {
        _this4.$refs.form && _this4.$refs.form.clearValidate();
      });
    },
    handleCancel: function handleCancel() {
      this.visible = false;
      this.resetForm();
    },
    onFreezeTimeChange: function onFreezeTimeChange() {
      this.$refs.form && this.$refs.form.validateField('freezeStart');
    },
    handleConfirm: function handleConfirm() {
      var _this5 = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
          var _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                if (valid) {
                  _context.n = 1;
                  break;
                }
                return _context.a(2);
              case 1:
                if (_this5.form.attachment) {
                  _context.n = 2;
                  break;
                }
                _this5.$message.warning('请上传附件后再确认冻结。');
                return _context.a(2);
              case 2:
                _this5.submitting = true;
                _context.p = 3;
                _context.n = 4;
                return shopCarOrderApi.freezeParkingCard({
                  orderNo: _this5.orderNo,
                  freezeStartTime: _this5.form.freezeStart,
                  freezeEndTime: _this5.form.freezeEnd,
                  reason: _this5.form.reason,
                  attachment: _this5.form.attachment
                });
              case 4:
                _this5.$message.success('冻结操作提交成功');
                _this5.$emit('success');
                _this5.handleCancel();
                _context.n = 6;
                break;
              case 5:
                _context.p = 5;
                _t = _context.v;
                if (_t && _t.message === '附件上传失败') _this5.$message.error(_t.message);
              case 6:
                _context.p = 6;
                _this5.submitting = false;
                return _context.f(6);
              case 7:
                return _context.a(2);
            }
          }, _callee, null, [[3, 5, 6, 7]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};